<div fxLayout="column" id="top" class="cardpadding">
    <mat-card fxLayout="column" fxLayoutGap="10px">
        <div class="color-primary backgroud-color-white  ">
            <div fxLayout="row" fxLayoutAlign="space-between">

                <p class="mat-title">Import new lead
                </p>
                <button mat-raised-button color="primary" routerLink="/admin/leads">
                    <mat-icon class="cursor-pointer">arrow_back</mat-icon> Back
                </button>
            </div>
        </div>
        <div>
            <mat-divider>
            </mat-divider>
        </div>
        <div fxLayout="column" fxLayoutGap="20px">

            <div>
                <button mat-raised-button color="primary" (click)="export()">Sample File Export</button>
            </div>
            <div fxLayout="column" fxLayoutGap="10px">
                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">

                    <form [formGroup]="myForm">
                        <div fxLayout="column" fxLayoutGap="20px">
                            <div fxLayout="column" fxLayoutGap="20px">
                                <p class="mat-h3 color-primary">Choose CSV/ Excel File:</p>
                                <button mat-raised-button (click)="fileImportInput.click()" color="primary"> Choose CSV
                                    /
                                    Excel File
                                </button>

                                <input class="display-none" formControlName="file" #fileImportInput id="file"
                                    type="file" (change)="onFileChange1($event)"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                <!-- onFileChange -->
                            </div>
                            <div fxFlex="32">
                                <mat-form-field appearance="outline" class="full-width form-field-font">
                                    <mat-label>Assigned</mat-label>
                                    <mat-select placeholder="Assigned" (selectionChange)="AssignedEmployee($event)"
                                        formControlName="assigned">
                                        <mat-select-filter [array]="filteredListEmployee" [displayMember]="'name'"
                                            (filteredReturn)="filteredList1 =$event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList1" [value]="item.userId">
                                            {{item.firstName}}
                                            {{item.lastName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </div>
                            <button mat-raised-button color="primary" (click)="submit()"
                                [disabled]="myForm.invalid">Import</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </mat-card>
</div>
<!-- <p>excelsheet works!</p> -->
<!-- 
 -->
<!-- <input type="file" (change)="onFileChange1($event)" color="primary" multiple="false" />
 <pre>{{this.data}}</pre> -->
<!-- <button mat-raised-button (click)="onFileChange1($event)" color="primary"> Choose -->
<!-- </button> -->
<!-- 
   
<table >
    <tbody>
        <tr *ngFor="let row of data">

            {{row}}
                <td *ngFor="let cell of row">
                        {{cell}}
                </td>
        </tr>
    </tbody>
</table> -->